import {Content, List, Root, Trigger} from '@radix-ui/react-tabs';
import cx from 'classnames';

import {Text} from '#component/base/Text/Text';

import {TabsProps} from './Tabs.types';

import * as css from './Tabs.css';

export const Tabs = ({
  activationMode = 'manual',
  listProps = {},
  tabs = [],
  ...otherProps
}: TabsProps) => {
  const {className, ...otherListProps} = listProps || {};
  return (
    <Root defaultValue="0" orientation="horizontal" {...otherProps}>
      <List className={cx(css.list, className)} {...otherListProps}>
        {tabs.map(({disabled, label}, i) => (
          <Text
            as={Trigger}
            className={css.tab}
            disabled={disabled}
            key={i}
            value={`${i}`}
            variant="button">
            {label}
          </Text>
        ))}
      </List>

      {tabs.map(({content, forceMount}, i) => (
        <Content
          className={css.content}
          forceMount={forceMount || undefined}
          key={i}
          value={`${i}`}>
          {content}
        </Content>
      ))}
    </Root>
  );
};
